import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useProductDetailContext } from '../../ProductDetailContext';

export const useIsRichContentFirstTab = () => {
  const {
    product: { brand, masterProductCode },
  } = useProductDetailContext();
  const id = brand?.id;

  const { pd_display_rich_content_as_first_tab_by_ids } = useFeatureFlags();

  const brandMatches =
    pd_display_rich_content_as_first_tab_by_ids?.brandIds?.some(
      (brandId) => brandId?.toLowerCase() === id?.toLowerCase()
    );

  const masterProductCodeMatches =
    pd_display_rich_content_as_first_tab_by_ids?.masterProductCodes?.some(
      (masterCode) =>
        masterCode?.toLowerCase() === masterProductCode?.toLowerCase()
    );

  return brandMatches || masterProductCodeMatches;
};
